---
title: "Gage After Party at Converge 2026"
keywords: "Converge 2026 after party, Gage after party, IAUG Converge, Sorry Charlie's, Bamboo Room tiki bar, Savannah after hours networking, Converge party registration"
seo:
  title: "Gage After Party at Converge 2026 | November 3, 7 to 9 PM"
  description: "Join the Gage team for our Converge 2026 after party. Tuesday, November 3, 7 to 9 PM at the Bamboo Room at Sorry Charlie's in downtown Savannah. Food and drinks on us. Space is limited, so register early."
  image: "/img/converge-afterparty/bamboo-room-interior.webp"
  twitter:
    card: "summary_large_image"
    title: "Gage After Party at Converge 2026 | November 3, 7 to 9 PM"
    description: "Food, drinks, and good company at the Bamboo Room at Sorry Charlie's. Space is limited, so register early."
    image: "/img/converge-afterparty/bamboo-room-interior.webp"
---

<PotsAlertBar>
  <strong>Tuesday, November 3, 2026</strong> | 7:00 to 9:00 PM | Sorry Charlie's Bamboo Room, Savannah <a href="#register">Register below</a>
</PotsAlertBar>

<PotsHero
  title="Gage After Party at Converge"
  description="The exhibit hall empties, the sessions wrap, and the best conversations of the week move to a tiki bar. Join the Gage team for food and drinks at the Bamboo Room, Sorry Charlie's tropical hideaway in downtown Savannah. Come unwind, meet some great people, and have a good time."
  ctaText="Register for the Party"
  ctaHref="#register"
  ctaSubtext="Space is limited, so register early"
/>

<div class="converge-city-banner">
  <img src="/img/converge-afterparty/bamboo-room-interior.webp" alt="Inside the Bamboo Room tiki bar, with bamboo walls, hanging lanterns, and warm string lights" />
  <div class="converge-city-banner-text">
    <p class="city-name">The Bamboo Room</p>
    <p class="city-tagline">Tuesday, November 3 | 7:00 to 9:00 PM | Sorry Charlie's, Savannah</p>
  </div>
  <span class="converge-city-banner-credit">Photo: Bamboo Room Tiki Bar</span>
</div>

<Section>
  <PotsEyebrow>Party Details</PotsEyebrow>
  ## When, Where, and What to Expect

  Here's the plan. We take over the Bamboo Room, the tiki bar upstairs from Sorry Charlie's Oyster Bar on Ellis Square, on Tuesday night of Converge. Food and drinks are on us. Everyone at the conference is welcome, customers and friends alike, so bring a colleague or two.

  <div class="afterparty-details-grid">
    <div class="afterparty-detail-card">
      <div class="afterparty-detail-label">When</div>
      <div class="afterparty-detail-text">Tuesday, November 3, 2026<br/>7:00 to 9:00 PM</div>
    </div>
    <div class="afterparty-detail-card">
      <div class="afterparty-detail-label">Where</div>
      <div class="afterparty-detail-text">The Bamboo Room at Sorry Charlie's<br/>116 West Congress Street, Savannah</div>
    </div>
    <div class="afterparty-detail-card">
      <div class="afterparty-detail-label">What's on</div>
      <div class="afterparty-detail-text">Food and drinks, on us<br/>No badge scan, no pitch, just a good time</div>
    </div>
    <div class="afterparty-detail-card">
      <div class="afterparty-detail-label">Getting there</div>
      <div class="afterparty-detail-text">Ferry across the river from the convention center, then a short walk<br/>Or about a 10-minute Uber</div>
    </div>
  </div>

  <PotsCallout>
    <p><strong>Finding it:</strong> The Bamboo Room is upstairs from Sorry Charlie's Oyster Bar, right on Ellis Square at 116 West Congress Street. Look for the neon.</p>
  </PotsCallout>
</Section>

<Section data-gray>
  <PotsEyebrow>The Spot</PotsEyebrow>
  ## A Tiki Bar in the Middle of Downtown Savannah

  Sorry Charlie's opened the Bamboo Room as a second-floor tropical escape above its oyster bar, and it's become one of Savannah's favorite rooms. Bamboo walls, carved tikis, lanterns overhead, and a serious drink menu. It's the right setting for a Tuesday night at Converge.

  <div class="converge-venue-grid">
    <div class="converge-venue-item">
      <img src="/img/converge-afterparty/bamboo-room-cocktails.webp" alt="Colorful tiki cocktails in skull and tiki mugs lined up on the Bamboo Room bar" />
    </div>
    <div class="converge-venue-item">
      <img src="/img/converge-afterparty/bamboo-room-bar.webp" alt="The Bamboo Room bar area with warm red and amber lighting and tiki carvings" />
    </div>
  </div>
</Section>

<Section id="register">
  <PotsEyebrow>Save Your Spot</PotsEyebrow>
  ## Register for the Gage After Party at Converge

  Just fill in your details and you're on the list. We'll have your name at the door.

  <PartyRegistrationForm>
    ## You're Invited.<br/>Save Your Spot.

    <p class="pots-contact-subcopy" style="text-align: center; margin-left: auto; margin-right: auto;">Space is limited, so register early. One registration per person, and colleagues are welcome to sign up too.</p>
  </PartyRegistrationForm>
</Section>
